(function() {
    'use strict';
    angular
        .module('MW.ContactManager.RecentDocuments', [
            'MW.Framework.InfluencerContactService',
            'MW.Influencers.AnalyticsService',
            'MW.Framework.AnalyticsConstants',
            'ngHaakon.components',
            'MW.Framework.ContentStreamDocumentRow'
        ])
        .directive('recentDocumentsPublished', function () {
            return {
                restrict: 'E',
                templateUrl: 'icm-web/views/recent_documents_published',
                replace: true,
                scope: {
                    documents : '&?',
                    documentsConfig: '=?',
                    pendingData: '&?',
                    profileType: '@',
                    sourceIds: '<'
                },
                controller: ContactRecentDocumentController
            };
        })
        .controller('ContactRecentDocumentController', [
            'InfluencerContactService',
            '$scope',
            'ContentBehaviorService',
            '$routeParams',
            'translationService',
            'AnalyticsService',
            'ANALYTICS_CONSTANTS',
            ContactRecentDocumentController
        ]);


    function ContactRecentDocumentController(InfluencerContactService, $scope,  ContentBehaviorService, $routeParams, translationService, AnalyticsService, ANALYTICS_CONSTANTS) {
        //call to get the recent documents from documentService
        $scope.rowSettings = {};
        $scope.pendingData = true;
        var searchQueryType,
            ids;

        if ($scope.profileType === 'source') {
            searchQueryType = 'source';
            ids = $scope.sourceIds;
        } else if ($scope.profileType === 'contact') {
            searchQueryType = 'contact';
            ids = [$routeParams.contactId];

            getRecentDocuments();
        }

        $scope.$watch('sourceIds', function(newValue) {
            if(newValue && (newValue !== ids)) {
                ids = $scope.sourceIds;

                getRecentDocuments();
            }
        });

        function getRecentDocuments() {
            InfluencerContactService.getRecentDocuments(searchQueryType, ids).then(function(response) {
                $scope.pendingData = false;
                $scope.documents = response;
                $scope.documentsConfig = {
                    documentClick: function documentClick (event, document, fullContentDialog, url) {
                        var documentDetail = {
                            document: document,
                            parentType: ANALYTICS_CONSTANTS.RECENT_RESULTS,
                            label : ANALYTICS_CONSTANTS.OPEN,
                            sourceDetail: document.source
                        };
                        event.preventDefault();

                        AnalyticsService.documentOperation(documentDetail);
                        ContentBehaviorService.documentClick(document, url);
                    }
                };
                if ($scope.documents && $scope.documents.documents){
                    angular.forEach($scope.documents.documents, function(documentObj) {
                        documentObj.redirectUrl = ContentBehaviorService.buildRedirectUrl(documentObj, $scope.documentsConfig);

                        //Key for handling mutual toggle for duplicates
                        documentObj.duplicates = {};
                        if(documentObj.dupDocs && documentObj.dupDocs.length) {
                            documentObj.duplicates.show = false;
                        }
                    });
                } else {
                    $scope.pendingData = true;
                }
            }, function () {
                if ($scope.documents && $scope.documents.documents) {
                    $scope.documents.documents = [];
                }
                $scope.pendingData = true;
            });
        }

        $scope.getDupDocsCountWhen = function getDupDocsCountWhen(document) {
            if(document.dupDocs && document.dupDocs.length) {
                return {
                    1: translationService.getLocalizedString('1 more article'),
                    other: translationService.getLocalizedString('[[numArticles]] more articles', {numArticles: document.dupDocs.length})
                };
            } else {
                return null;
            }
        };

        $scope.documentClick = function documentClick($event, document, url){
                $event.preventDefault();
                ContentBehaviorService.documentClick(document, url);
        };

        $scope.toggleRecentDuplicateDocs = function toggleRecentDuplicateDocs(document) {
            document.duplicates.show = !document.duplicates.show;
        };
    }
}());
